// Blockchain adapter interface
import { Address, Chain } from 'wagmi'
export enum BlockchainType {
  ETHEREUM = 'ethereum',
  TRON = 'tron',
}

export type BalanceResult = {
  token?: string
  formatted: string
  value: number | bigint | null
  decimals: number
  symbol: string
}
export const EMPTY_BALANCE: BalanceResult = {
  value: null,
  formatted: '-',
  symbol: '',
  decimals: 0,
}

export type BlockchainAdapter = {
  isConnected: boolean
  chain?: Chain

  // Actions
  connect: (connector: string) => void
  disconnect: () => void

  signMessage: (message: string) => Promise<string>
  sendTransaction: (contract: string, amount: number, to: string) => Promise<string>
  getBalances: (contracts: string[], address: string) => Promise<BalanceResult[]>
  hasPublicClient: boolean
  walletType: string | undefined
} & (
  | { type: BlockchainType.ETHEREUM; address: Address | undefined }
  | { type: BlockchainType.TRON; address: `T${string}` | undefined }
)
